<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por descrição"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
    
    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>
    
    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-6">
          <label for="ticket-day">Data inicial</label>
          <input v-model="query.startDate" type="date" id="ticket-day" class="form-control">
        </div>
        
        <div class="col-md-6">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button class="btn btn-primary mt-1 mr-1" @click="openModal">
          Novo
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <Table :ticketDescriptions="ticketDescriptions" @deleteEntity="deleteEntity"/>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>

    <Modal v-model="showModal" v-if="currentTicketDescription">
      <span slot="header">Novo</span>
      <Form
        :ticketDescription="currentTicketDescription"
        @cancel="showModal = false"
        @saveEntity="saveEntity($event)"
      />
    </Modal>
  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Form from './Form'

  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import Table from './Table'

  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  
  export default {
    components: { BadgeFilters, ChevronDownIcon, Form, Modal, Pagination, SearchIcon, Table },
    computed: {
      badgeFilters() {
        return [this.filterEndDate, this.filterStartDate]
      },
      ticketDescriptions() {
        return this.getModels || []
      },
    },
    created() {
      this.addOrderBy('updatedAt')

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data: () => ({
      currentTicketDescription: null,
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      nameModel: 'TicketDescription',
      showModal: false,
    }),
    methods: {
      deleteEntity(ticketDescription) {
        if (!confirm('Tem certeza?'))
          return

        this.asyncTemplateDelete(ticketDescription, {
          after: () => {
            this.$notify.add('Excluído com sucesso.')
            this.find()
          }
        })
      },
      buildPath() {
        return 'admin/maestro/ticket_descriptions'
      },
      find() {
        this.asyncTemplateSelect()
      },
      openModal() {
        this.showModal = true
        this.currentTicketDescription = {}
      },
      saveEntity(ticketDescription) {
        this.asyncTemplateSave(ticketDescription, {
          after: () => {
            this.$notify.add('Salvo com sucesso!')
            this.showModal = false
            this.find()
          }
        })
      }
    },
    mixins: [ModelMapper],
    name: 'Index',
  }
</script>

<style scoped>
  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }
</style>